import * as ActionTypes from '../redux/ActionTypes';

export default (state=[], action) => {
	if (action.type === ActionTypes.SETWORKSHOP) {
		return [ ...state, ...action.workshops ];
	} else {
		return state;
	}
}
